import React from "react";
import PropTypes from "prop-types";
import "./ToggleSwitch.style.scss";

const ToggleSwitch = ({
  id,
  checked,
  handler,
  size,
  grey,
  text_on,
  text_off,
}) => {
  return (
    <label
      className={`toggle_switch ${size === "big" ? "toggle_switch_big" : ""}`}
    >
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={() => handler()}
      />
      <div
        className={`toggle_switch_slider toggle_switch_slider_round ${
          checked && size === "big"
            ? "toggle_switch_slider_big_on"
            : checked
            ? "toggle_switch_slider_on"
            : "toggle_switch_slider_off"
        }
        ${grey ? "toggle_switch_slider_grey" : ""}
        `}
        data-on-label={text_on ? text_on : "ON"}
        data-off-label={text_off ? text_off : "OFF"}
      ></div>
    </label>
  );
};

ToggleSwitch.propTypes = {
  id: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  handler: PropTypes.func,
};

export default ToggleSwitch;



// WEBPACK FOOTER //
// ./src/components/common/toggleSwitch/ToggleSwitch.jsx